"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _marked = _interopRequireDefault(require("marked"));

var _constellation = require("@zillow/constellation");

var _helper = require("../utils/helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Homepage banner
 */
var HomePageBanner = function HomePageBanner(_ref) {
  var buttonText = _ref.buttonText,
      adImage = _ref.adImage,
      bgImage = _ref.bgImage,
      clickAction = _ref.clickAction,
      hoverAction = _ref.hoverAction,
      description = _ref.description,
      headline = _ref.headline,
      legalText = _ref.legalText;
  return /*#__PURE__*/_react.default.createElement(_constellation.Box, {
    sx: {
      'position': 'relative',
      'border': 'none',
      'borderRadius': '$spacing.none',
      'maxWidth': '100%',
      'padding': '$spacing.none',
      'textAlign': 'left',
      'backgroundColor': '$colors.backgroundDarkBlue',
      '.hpBannerTextColor': {
        color: '$colors.white'
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_constellation.Flex, {
    display: "flex",
    flexDirection: "row-reverse",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "wrap"
  }, /*#__PURE__*/_react.default.createElement(_constellation.Box, {
    sx: {
      'display': 'flex',
      'flexGrow': '1',
      'flexShrink': '1',
      'alignSelf': 'stretch',
      '@media $xs': {
        flexBasis: '492px'
      },
      '@media $lg': {
        flexBasis: '277px'
      },
      '@media $xl': {
        flexBasis: '277px',
        flexGrow: '1'
      },
      'img': {
        objectFit: 'cover'
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_constellation.Image, {
    alt: (0, _helper.imageAlt)(bgImage, headline),
    src: bgImage.src,
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/_react.default.createElement(_constellation.Flex, {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: "277px"
  }, /*#__PURE__*/_react.default.createElement(_constellation.Box, {
    sx: {
      '@media $xs': {
        'padding': '24px 32px',
        '.hpBannerHeading': {
          fontSize: '24px',
          lineHeight: '32px'
        }
      },
      '@media $xl': {
        'padding': '36px 88px',
        '.hpBannerHeading': {
          fontSize: '36px',
          lineHeight: '48px'
        }
      },
      '@media $xxl': {
        'padding': '64px 64px 64px 125px',
        '.hpBannerHeading': {
          fontSize: '48px',
          lineHeight: '64px'
        }
      },
      '@media screen and (min-width: 1328px)': {
        maxWidth: '700px',
        marginLeft: 'auto'
      }
    }
  }, adImage && adImage.src ? /*#__PURE__*/_react.default.createElement(_constellation.Box, {
    className: "hpBannerAdImage",
    sx: {
      background: 'none',
      textAlign: 'left',
      padding: '$spacing.none',
      maxWidth: '230px'
    }
  }, /*#__PURE__*/_react.default.createElement(_constellation.Image, {
    alt: (0, _helper.imageAlt)(adImage, 'ad logo'),
    src: adImage.src,
    width: "100%",
    height: "100%"
  })) : null, /*#__PURE__*/_react.default.createElement(_constellation.Heading, {
    level: 2,
    marginTop: "lg",
    className: "hpBannerHeading hpBannerTextColor",
    dangerouslySetInnerHTML: {
      __html: _marked.default.parseInline(headline)
    }
  }), /*#__PURE__*/_react.default.createElement(_constellation.Paragraph, {
    marginTop: "md",
    className: "hpBannerBody hpBannerTextColor",
    dangerouslySetInnerHTML: {
      __html: _marked.default.parseInline(description)
    }
  }), /*#__PURE__*/_react.default.createElement(_constellation.Button, {
    marginTop: "md",
    marginBottom: "md",
    buttonType: "primary",
    onClick: clickAction,
    onKeyDown: clickAction,
    onMouseEnter: hoverAction,
    mediaQuery: {
      xl: {
        marginTop: 'xl'
      }
    }
  }, buttonText), legalText ? /*#__PURE__*/_react.default.createElement(_constellation.Text, {
    as: "p",
    className: "hpBannerLegal hpBannerTextColor",
    onClick: function onClick(e) {
      e.stopPropagation();
    },
    dangerouslySetInnerHTML: {
      __html: _marked.default.parseInline(legalText)
    }
  }) : null))));
};

HomePageBanner.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Advertisement image displayed in component
   */
  adImage: _propTypes.default.shape({
    /**
     * The alt text of the image.
     */
    alt: _propTypes.default.string,

    /**
     * The url of the image. This is used as an alternative to icon.
     */
    src: _propTypes.default.string
  }),

  /**
   * Background image displayed in component
   */
  bgImage: _propTypes.default.shape({
    /**
     * The alt text of the image.
     */
    alt: _propTypes.default.string,

    /**
     * The url of the image. This is used as an alternative to icon.
     */
    src: _propTypes.default.string
  }),

  /**
   * Text on the button displayed in the component
   */
  buttonText: _propTypes.default.string.isRequired,

  /**
   * Action on clicking the component
   */
  clickAction: _propTypes.default.func.isRequired,

  /**
   * Action on hover over the component
   */
  hoverAction: _propTypes.default.func.isRequired,

  /**
   * Description displayed in the component
   */
  description: _propTypes.default.string.isRequired,

  /**
   * Heading displayed in the component
   */
  headline: _propTypes.default.string.isRequired,

  /**
   * Legal text displayed at the bottom below the CTA button. Supports html.
   * If you want to update css, use class selector hp-banner-legal-text and apply css overrides
   */
  legalText: _propTypes.default.string
} : {};
HomePageBanner.defaultProps = {
  legalText: '',
  bgImage: {},
  adImage: {}
};
var _default = HomePageBanner;
exports.default = _default;